"use strict";
var Model = require("../types/Model");

module.exports = Model({
	name: "stafflist",
	init: init,
	listeners: listeners,

	refresh: refresh,
	recalculate: recalculate,
	trackChanges: trackChanges,
	process_people: process_people
});

function listeners(){
	return {
		"connectivity:online": refresh,
		"people:updated": Model.makeRecalculator("people"),
		"orggroup:updated": handle_orggroup_update
	};
}

function init(){
	this._rawList = [];
	this._tracker = this.dispatcher.createTracker();
	this.push([]);
	this.refresh();
}

function recalculate(){
	var people = this._people;
	var rawList = this._rawList;

	var list = rawList.reduce(function(acc, person){
		var newPerson = people[person];
		if(newPerson) acc = acc.concat(newPerson);
		return acc;
	}, []);

	if(list.length)
		this.push(list);
}

function refresh(){
	this.api.org.staff.list()
		.then(handle_users.bind(this));
}

function handle_users(list){
	this.process_people(list);
	this._rawList = list;
	this.recalculate();
}

function handle_orggroup_update(orggroup){
	this._orgGroup = orggroup;
	this.trackChanges();
}

function process_people(people){
	this.emit("people:trigger:add", {
		lean: true,
		who: people
	});
}

function add_staff(data){
	var staff = data.who;
	var list = this._rawList;
	this.process_people(staff);
	var newList = list.concat(staff);
	this._rawList = newList;
	this.recalculate();
}

function remove_staff(data){
	var staff = data.who;
	var list = this._rawList;
	var newList = list.filter(function(person){
		return person._id !== staff;
	});
	this._rawList = newList;
	this.recalculate();
}

function trackChanges(){
	var orgGroup = this._orgGroup;
	var tracker = this._tracker;
	if(!orgGroup) return;

	tracker.off();
	tracker.on("mqtt:orggroup/" + orgGroup + "/staff/added", add_staff.bind(this));
	tracker.on("mqtt:orggroup/" + orgGroup + "/staff/removed", remove_staff.bind(this));
}